/**
 * Returns `list` with `value` removed if it is already present, or appended if it is not.
 * Never mutates the input.
 *
 * The multi-select filter dimensions (category, amount, brand, vendor) all toggle this way, on
 * both the desktop rail (`useSearchFilters`) and the mobile sheet (`FilterSheet`). Written out
 * inline, each copy renamed its callback parameter, so a grep for one spelling missed the others
 * and a change to toggle semantics needed six coordinated edits — with the rail and the sheet
 * drifting apart on the same dimension as the classic outcome (#226 review F10).
 *
 * Membership is exact equality (`Array.prototype.includes`), which is what the URL layer expects:
 * `parseFilters` preserves whitespace and case, so `" Acme"` and `"Acme"` are two different
 * filters and must toggle independently.
 */
export const toggled = <T>(list: T[], value: T): T[] =>
    list.includes(value)
        ? list.filter((item) => item !== value)
        : [...list, value];
